import type { ErrorEvent } from '@sentry/react'

// Overrides Sentry's default stack-trace-based grouping for AxiosError failures, where the
// *logical* error (a given endpoint returning a given status) is identical across releases, but
// the default fingerprint (derived from the minified stack) isn't stable across deploys — splitting
// one real, recurring issue into a new "issue" every release. Seen live: the same "404 on
// /parking/:ticketNumber/services-info" split across 4 separate Sentry issues. Grouped instead by
// status + route pattern, independent of the stack. `event.transaction` already holds the route
// *pattern* (e.g. `/parking/:ticketNumber/payment`), not the expanded literal path, courtesy of
// reactRouterV6BrowserTracingIntegration in sentryConfig.js.
const AXIOS_STATUS_PATTERN = /Request failed with status code (\d+)/

export const applyCustomFingerprint = (event: ErrorEvent): ErrorEvent => {
  const value = event.exception?.values?.[0]?.value
  if (!value) return event

  const statusMatch = value.match(AXIOS_STATUS_PATTERN)
  if (statusMatch) {
    event.fingerprint = ['axios-error', statusMatch[1], event.transaction ?? 'unknown-route']
  }

  return event
}
